module.exports = __webpack_public_path__ + "img/kael-escape.b513873.jpg";